import LingvoSemantic from "./LingvoSemantic"; // Основной компонент

export { LingvoSemantic }; // Экспортируем всё необходимое
export default LingvoSemantic; // Экспорт по умолчанию
